<template>
   <v-container fluid>
      <v-row no-gutters class="d-flex">
         <v-row no-gutters>
            <v-col cols="12" class="pt-0">
               <v-toolbar dense :color="this.$globalstore.secondary_titleclass">
                  <v-toolbar-title>
                     <span v-if="$vuetify.breakpoint.mdAndUp">
                        Add Group:
                     </span>
                     {{ this.edit_cca_term }}
                     {{ this.edit_cca_year }}
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-btn color="indigo" class="white ma-2" outlined @click="goBack()">
                     Cancel
                  </v-btn>
                  <v-btn color="indigo" class="white ma-2" outlined @click="SaveGroup">
                     Save
                  </v-btn>
               </v-toolbar>
               <v-sheet>
                  <v-form ref="groupform" v-model="groupform_valid">
                     <v-row no-gutters class="pa-0 mt-2 d-flex flex-wrap">
                        <v-col cols="10" md="4">
                           <v-text-field
                              label="Group Name"
                              class="ml-3 mt-1 mb-0"
                              v-model="edit_cca_name"
                              required
                              :rules="rules_cca_name"
                              :counter="NameMaxLength"
                              :maxlength="NameMaxLength"
                           >
                           </v-text-field>
                           <v-text-field
                              v-model="edit_cca_description"
                              label="Group Description"
                              class="ml-3 my-0"
                              required
                              :rules="rules_cca_description"
                              type="text"
                              :counter="DescriptionMaxLength"
                              :maxlength="DescriptionMaxLength"
                           >
                           </v-text-field>
                        </v-col>
                        <v-col cols="8" md="2" class="px-2">
                           <v-select
                              class="mt-1"
                              label="Status"
                              :items="$globalstore.status_select"
                              item-text="text"
                              item-value="id"
                              return-object
                              v-model="edit_cca_status"
                              :rules="[(v) => !!v || 'Status is required']"
                              required
                           >
                           </v-select>
                           <v-select
                              class="mt-0"
                              label="Gender"
                              :items="$globalstore.gender_select"
                              item-text="text"
                              item-value="id"
                              return-object
                              v-model="edit_gender_constraint"
                              :rules="[(v) => !!v || 'Gender is required']"
                              required
                           >
                           </v-select>
                        </v-col>
                        <v-col cols="6" md="2" class="px-2">
                           <datepicker-dialog
                              labelname="Publish Date"
                              @return-date="onPublishDateChange"
                           >
                           </datepicker-dialog>
                           <label class="caption mr-1" for="publishtime">Publish Time </label>
                           <vue-timepicker
                              close-on-complete
                              name="publishtime"
                              :minute-interval="$globalstore.minute_interval"
                              v-model="edit_publishtime"
                              drop-direction="down"
                              manual-input
                              auto-scroll
                           ></vue-timepicker>
                        </v-col>
                        <v-col cols="6" md="2" class="px-2">
                           <datepicker-dialog
                              labelname="Closing Date"
                              @return-date="onClosingDateChange"
                           >
                           </datepicker-dialog>
                           <label class="caption mr-1" for="closingtime">Closing Time</label>
                           <vue-timepicker
                              close-on-complete
                              name="closingtime"
                              :minute-interval="$globalstore.minute_interval"
                              v-model="edit_closingtime"
                              drop-direction="down"
                              manual-input
                              auto-scroll
                           ></vue-timepicker>
                        </v-col>
                        <v-col cols="12" md="2">
                           <v-checkbox
                              class="ml-4"
                              label="Consent Required"
                              v-model="edit_consent_required"
                           ></v-checkbox>
                           <v-select
                              class="ml-5 my-0"
                              label="Limit Participant"
                              :items="limitselect"
                              item-text="text"
                              item-value="id"
                              v-model="edit_limit_participant"
                              required
                           ></v-select>
                        </v-col>
                     </v-row>
                     <v-row no-gutters class="pa-0 d-flex">
                        <v-col cols="12" md="6">
                           <year-select :years.sync="edit_year_constraint"> </year-select>
                        </v-col>
                        <v-col cols="4" md="2" class="pl-2">
                           <v-card flat outlined>
                              <v-card-text>
                                 <v-text-field
                                    class="pt-2"
                                    label="Minimum Participant"
                                    v-model="edit_min_participant"
                                    :rules="rules_min_participant"
                                 ></v-text-field>
                              </v-card-text>
                           </v-card>
                        </v-col>
                        <v-col cols="4" md="2" class="pl-2">
                           <v-card flat outlined>
                              <v-card-text>
                                 <v-text-field
                                    class="pt-2"
                                    label="Maximum Participant"
                                    v-model="edit_max_participant"
                                    :rules="rules_max_participant"
                                    required
                                 ></v-text-field>
                              </v-card-text>
                           </v-card>
                        </v-col>
                        <v-col cols="4" md="2" class="pl-2">
                           <v-card flat outlined>
                              <v-card-text>
                                 <v-text-field
                                    class="pt-2"
                                    label="CCA Fee"
                                    v-model="edit_cca_fee"
                                    :rules="rules_cca_fee"
                                 ></v-text-field>
                              </v-card-text>
                           </v-card>
                        </v-col>
                     </v-row>
                     <v-card outlined>
                        <v-row no-gutters>
                           <v-col cols="4" md="4">
                              <v-select
                                 class="ml-2"
                                 label="CCA Schedule"
                                 :items="edit_scheduledata"
                                 item-text="schedule_name"
                                 item-value="id"
                                 return-object
                                 v-model="edit_schedule"
                                 required
                                 :rules="[(v) => !!v || 'Schedule is required']"
                              >
                              </v-select>
                           </v-col>
                           <v-col cols="4" md="2" class="px-2">
                              <v-text-field
                                 disabled
                                 v-if="edit_schedule"
                                 label="Start Date"
                                 readonly
                                 v-model="edit_schedule.schedule_startdate"
                              ></v-text-field>
                           </v-col>
                           <v-col cols="4" md="2" class="px-2">
                              <v-text-field
                                 disabled
                                 v-if="edit_schedule"
                                 label="End Date"
                                 readonly
                                 v-model="edit_schedule.schedule_enddate"
                              ></v-text-field>
                           </v-col>
                           <v-col cols="4" md="4" class="px-2">
                              <v-select
                                 class="mt-0"
                                 label="Category"
                                 :items="categorylist"
                                 item-text="category_name"
                                 item-value="id"
                                 return-object
                                 v-model="edit_ccacategory"
                                 required
                              >
                              </v-select>
                           </v-col>
                        </v-row>
                     </v-card>
                     <!-- bottom section -->
                     <v-row no-gutters>
                        <!-- left bottom -->
                        <v-col cols="12" md="8">
                           <v-row no-gutters class="pa-0 ma-0">
                              <v-col md="2">
                                 <div class="ml-3 mt-2 text-start">
                                    <b>Event Master</b>
                                 </div>
                              </v-col>
                              <v-col md="10">
                                 <div class="py-2">
                                    <v-btn x-small class="primary" @click="AddEventData">
                                       <v-icon small>mdi-plus</v-icon>
                                       Add
                                    </v-btn>
                                 </div>
                              </v-col>
                           </v-row>
                           <!-- Event Master table -->
                           <v-row no-gutters>
                              <v-col md="12">
                                 <v-card class="overflow-y-auto" height="200px">
                                    <v-data-table
                                       dense
                                       :headers="eventdata_headers"
                                       hide-default-footer
                                       :items="edit_eventdata"
                                       @click:row="rowClickEventMaster"
                                       item-key="unique_id"
                                       sort-by="unique_id"
                                       single-select
                                       @item-selected="ShowItemSelected"
                                    >
                                       <!-- eslint-disable-next-line -->
                                       <template #item.actions="{ item }">
                                          <v-icon small @click="editEventData(item)"
                                             >mdi-pencil</v-icon
                                          >
                                          <v-icon small @click="removeEventData(item)" class="ml-2"
                                             >mdi-delete</v-icon
                                          >
                                       </template>
                                    </v-data-table>
                                 </v-card>
                              </v-col>
                           </v-row>
                        </v-col>
                        <!-- Right bottom -->
                        <v-col cols="12" md="4">
                           <!-- admin button row -->
                           <v-row no-gutters class="pt-1">
                              <v-col md="4">
                                 <div class="ml-3 mt-2 text-start">
                                    <b>Administrators</b>
                                 </div>
                              </v-col>
                              <v-col md="8">
                                 <div class="my-0">
                                    <v-btn
                                       x-small
                                       class="primary ml-3 my-2"
                                       @click.native="adminlistdlg = true"
                                       ><v-icon small>mdi-plus</v-icon>
                                       Add
                                    </v-btn>
                                 </div>
                              </v-col>
                           </v-row>
                           <!-- Admininstrator table  -->
                           <v-row no-gutters class="full-height">
                              <v-col class="pl-2">
                                 <v-card class="overflow-y-auto" height="200px">
                                    <v-data-table
                                       dense
                                       :headers="admindata_headers"
                                       hide-default-footer
                                       :items="edit_admindata"
                                       @click:row="rowClickAdmin"
                                       item-key="id"
                                       sort-by="username"
                                       single-select
                                    >
                                       <!-- eslint-disable-next-line -->
                                       <template v-slot:item.actions="{item}">
                                          <v-icon small @click="removeAdminData(item)" class="ml-2">
                                             mdi-delete
                                          </v-icon>
                                       </template>
                                    </v-data-table>
                                 </v-card>
                              </v-col>
                           </v-row>
                        </v-col>
                     </v-row>
                     <!-- bottom section end    -->
                  </v-form>
               </v-sheet>
            </v-col>
         </v-row>
      </v-row>
      <confirm-dialog ref="confirm" />
      <group-admin-list
         ref="adminlist"
         :admindata="edit_admindata"
         :dialogvisible.sync="adminlistdlg"
         :multiselect="multiple_adminselect"
         @cancel-selection="adminlistdlg = false"
         @save-selection="onAdminSaveSelection"
      />
      <event-day ref="eventform" @input="onEventDayFormClose"></event-day>
   </v-container>
</template>

<script>
   import {GroupConst, DESCRIPTION_MAXLENGTH, NAME_MAXLENGTH} from "@/common/constant.js";
   import DatepickerDialog from "@/components/DatepickerDialog";
   import ConfirmDlg from "@/components/ConfirmDlg";
   import GroupAdminList from "../components/GroupAdminList.vue";
   import VueTimepicker from "vue2-timepicker/src/vue-timepicker.vue";
   import YearSelect from "../components/YearSelect.vue";
   import EventDay from "../components/EventDay.vue";

   export default {
      inject: ["ShowMessage"],

      components: {
         "datepicker-dialog": DatepickerDialog,
         "confirm-dialog": ConfirmDlg,
         "group-admin-list": GroupAdminList,
         VueTimepicker,
         YearSelect,
         EventDay,
      },
      data() {
         return {
            DescriptionMaxLength: DESCRIPTION_MAXLENGTH,
            NameMaxLength: NAME_MAXLENGTH,

            eventdata_headers: [
               {
                  text: "Day",
                  value: "daytext",
                  class: this.$globalstore.table_headerclass,
                  width: "20%",
               },
               {
                  text: "Start",
                  value: "start",
                  class: this.$globalstore.table_headerclass,
                  width: "15%",
               },
               {
                  text: "End",
                  value: "end",
                  class: this.$globalstore.table_headerclass,
                  width: "15%",
               },
               {
                  text: "Location",
                  value: "location_name",
                  class: this.$globalstore.table_headerclass,
                  width: "40%",
               },
               {
                  text: "",
                  value: "actions",
                  class: this.$globalstore.table_headerclass,
                  width: "10%",
                  sortable: false,
               },
            ],
            admindata_headers: [
               {
                  text: "Name",
                  align: "start",
                  value: "username",
                  class: this.$globalstore.table_headerclass,
               },
               {
                  text: "Role",
                  value: "userroles",
                  class: this.$globalstore.table_headerclass,
               },
               {
                  text: "",
                  value: "actions",
                  class: this.$globalstore.table_headerclass,
                  width: "5%",
                  sortable: false,
               },
            ],
            limitselect: GroupConst.limitselect,
            edit_scheduledata: [],
            edit_schedule: null,
            edit_ccacategory: null,
            categorylist: [],
            edit_cca_status: null,
            edit_cca_name: "",
            edit_cca_description: "",
            edit_cca_year: "",
            edit_cca_term: "",
            edit_cca_termyeartext: "",
            edit_gender_constraint: null,
            edit_year_constraint: [],
            edit_max_participant: 0,
            edit_min_participant: 1,
            edit_consent_required: false,
            edit_eventday: "",
            edit_eventtime: "",
            edit_starttime: "",
            edit_endtime: "",
            // id: unique_id, dow: dow, daytext: this.edit_eventday,
            // start: this.edit_starttime, end: this.edit_endtime
            edit_eventdata: [],
            admindata: [],
            edit_admindata: [],
            edit_adminselected: [],
            multiple_adminselect: true,
            adminlistdlg: false,
            // edit_publish_date: new Date(
            //    Date.now() - new Date().getTimezoneOffset() * 60000
            // )
            //    .toISOString()
            //    .substr(0, 10),
            edit_publish_date:
               this.$globalstore && this.$globalstore.appready
                  ? this.$globalstore.currentDateISOString().substr(0, 10)
                  : "",
            edit_publishtime:
               this.$globalstore && this.$globalstore.appready
                  ? this.$globalstore.appsettings.cca_publish_time
                  : "",
            // edit_closing_date: new Date(
            //    Date.now() - new Date().getTimezoneOffset() * 60000
            // )
            //    .toISOString()
            //    .substr(0, 10),
            edit_closing_date:
               this.$globalstore && this.$globalstore.appready
                  ? this.$globalstore.currentDateISOString().substr(0, 10)
                  : "",
            edit_closingtime:
               this.$globalstore && this.$globalstore.appready
                  ? this.$globalstore.appsettings.cca_closing_time
                  : "",
            edit_cca_fee: "0.00",
            edit_archived_date: "",
            edit_archived_by: "",
            edit_created_date: "",
            edit_created_by: "",
            edit_modify_date: "",
            edit_modify_by: "",
            edit_limit_participant: 0, //  0 = No Limitation 1 = Only students with  no CCA 2=By Invite
            edit_archive_remarks: "",
            //edit_locationdata: [],

            groupform_valid: true,
            rules_cca_name: [(v) => !!v || "Name is required"],
            rules_cca_description: [(v) => !!v || "Description is required"],
            rules_max_participant: [
               (v) => !!v || "Max participants must be 0 or above.",
               (v) => !!/^[0-9]+$/.test(v) || "Max participants must be numeric.",
            ],
            rules_min_participant: [
               (v) => !!v || "Min participants must be 1 or above.",
               (v) => !!/^[0-9]+$/.test(v) || "Min participants must be numeric.",
            ],
            rules_cca_fee: [
               (v) => !!/^\d+(\.\d{2})$/.test(v) || "CCA fee must have 2 numeric decimal places.",
            ],
         };
      },

      methods: {
         goBack() {
            this.$router.go(-1);
         },

         SaveGroup() {
            if (this.$refs.groupform.validate()) {
               if (this.edit_cca_name.length > 100) {
                  this.ShowMessage({
                     title: "Error",
                     message: "Group name must be 100 characters or less.",
                     color: "red",
                  });
                  return;
               }

               if (this.edit_cca_description.length > 1024) {
                  this.ShowMessage({
                     title: "Error",
                     message: "Group description must be 1024 characters or less.",
                     color: "red",
                  });
                  return;
               }

               let d1 = new Date(this.edit_publish_date);
               let d2 = new Date(this.edit_closing_date);

               if (d1 >= d2) {
                  this.ShowMessage({
                     title: "Error",
                     message: "Publish date has to be less than closing date.",
                     color: "red",
                  });
                  return;
               }

               if (!this.edit_publishtime || !this.edit_closingtime) {
                  this.ShowMessage({
                     title: "Error",
                     message: "Publish time and closing time is required.",
                     color: "red",
                  });
                  return;
               }

               if (
                  !Number.isInteger(parseInt(this.edit_max_participant)) ||
                  !Number.isInteger(parseInt(this.edit_min_participant))
               ) {
                  this.ShowMessage({
                     title: "Error",
                     message: "Minimum and maximum participants must be numeric.",
                     color: "red",
                  });
                  return;
               }

               if (
                  parseInt(this.edit_max_participant) < 0 ||
                  parseInt(this.edit_min_participant) < 0
               ) {
                  this.ShowMessage({
                     title: "Error",
                     message: "Minimum and maximum participants must be positive.",
                     color: "red",
                  });
                  return;
               }

               if (parseInt(this.edit_min_participant) == 0) {
                  this.ShowMessage({
                     title: "Error",
                     message: "Minimum participant must be greater than 0.",
                     color: "red",
                  });
                  return;
               }

               if (Number(this.edit_cca_fee) === NaN) {
                  this.ShowMessage({
                     title: "Error",
                     message: "CCA fee must be numeric.",
                     color: "red",
                  });
                  return;
               }

               let cca_fee = Number(Number.parseFloat(this.edit_cca_fee).toFixed(2));
               if (cca_fee > 0) {
                  this.edit_consent_required = true;
               }
               if (cca_fee > 0 && !this.edit_ccacategory.category_trancode) {
                  this.ShowMessage({
                     title: "Error",
                     message:
                        "Selected CCA Category: " +
                        this.edit_ccacategory.category_name +
                        " is not configured for payment.",
                     color: "red",
                  });
                  return;
               } else {
                  this.doSaveForm();
               }
            } else {
               this.ShowMessage({
                  title: "Error",
                  message: "Please complete the form.",
                  color: "red",
               });
               return;
            }
         },

         onEventDayFormClose(eventobj) {
            let event = eventobj.event;
            let mode = eventobj.mode;
            let previd = eventobj.previd;

            if (mode === "add") {
               let index = this.edit_eventdata.findIndex((x) => x.unique_id === event.unique_id);
               if (index === -1) {
                  this.edit_eventdata.push(event);
               } else {
                  this.ShowMessage({
                     title: "Error",
                     message: "Duplicate event day and time.",
                     color: "red",
                  });
               }
            } else if (mode === "edit") {
               if (previd === eventobj.unique_id) {
                  this.$set(this.edit_eventdata, index, event);
               } else {
                  // find out if edited data will conflict with
                  // existing data.
                  let index = this.edit_eventdata.findIndex((x) => x.unique_id === event.unique_id);

                  if (index != -1) {
                     this.ShowMessage({
                        title: "Error",
                        message: "Duplicate event day and time",
                        color: "red",
                     });
                  } else {
                     // Edited data has no confict. Now need to remove previd
                     // and insert new row
                     let index = this.edit_eventdata.findIndex((x) => x.unique_id === previd);
                     this.edit_eventdata.splice(index, 1);
                     this.edit_eventdata.push(event);
                  }
               }
            }
         },

         async doSaveForm() {
            let postdata = {
               schedule_id: this.edit_schedule.id,
               cca_name: this.edit_cca_name,
               cca_description: this.edit_cca_description,
               cca_status: this.edit_cca_status.id,
               cca_year: this.edit_cca_year,
               cca_term: this.edit_cca_term,
               gender_constraint: this.edit_gender_constraint.id,
               year_constraint:
                  this.edit_year_constraint.length > 0 ? this.edit_year_constraint.map(Number) : 0,
               min_participant: this.edit_min_participant,
               max_participant: this.edit_max_participant,
               consent_required: this.edit_consent_required ? 1 : 0,
               limit_participant: this.edit_limit_participant,
               publish_date: this.edit_publish_date,
               publish_time: this.edit_publishtime,
               closing_date: this.edit_closing_date,
               closing_time: this.edit_closingtime,
               cca_fee: this.edit_cca_fee,
               event_daytime: this.edit_eventdata,
               event_admin: this.edit_admindata,
               category_id: this.edit_ccacategory.id,
               userid: this.$globalstore.user.userid,
               token: this.$globalstore.user.usertoken,
            };

            await this.$http({
               url: "/cca/save_ccagroup.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: postdata,
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.goBack();
                  }
               }
            });
         },

         onPublishDateChange(event) {
            this.edit_publish_date = event;
         },
         onClosingDateChange(event) {
            this.edit_closing_date = event;
         },

         ShowItemSelected(event) {
            // console.log(event);
         },

         rowClickEventMaster(eventdata, row) {
            row.select(!row.isSelected);
         },

         rowClickAdmin(admin, row) {
            row.select(!row.isSelected);
         },

         async AddEventData() {
            if (await this.$refs.eventform.open()) {
               return;
            }
         },

         async editEventData(item) {
            if (await this.$refs.eventform.edit(item)) {
               return;
            }
         },

         removeEventData(item) {
            if (item) {
               let index = this.edit_eventdata.findIndex((x) => x.unique_id === item.unique_id);
               if (index != -1) this.edit_eventdata.splice(index, 1);
            }
         },

         onAdminSaveSelection(admin) {
            if (admin && admin.length) {
               for (let i = 0; i < admin.length; i++) {
                  this.edit_admindata.push(admin[i]);
               }
               this.adminlistdlg = false;
            }
         },

         removeAdminData(item) {
            if (item) {
               let index = this.edit_admindata.findIndex((x) => x.id === item.id);
               if (index != -1) this.edit_admindata.splice(index, 1);
            }
         },

         async loadScheduleList() {
            await this.$http({
               url: "/cca/getschedulelist.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  cca_year: this.edit_cca_year,
                  cca_term: this.edit_cca_term,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.edit_scheduledata = response.data.scheduledata;
                  }
               }
            });
         },

         async loadCategoryList() {
            await this.$http({
               url: "/billing/getccacategory.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  include_disabled: 0,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.categorylist = response.data.ccacategorydata;
                  }
               }
            });
         },
      },

      mounted() {
         if (this.$globalstore && this.$globalstore.appready) {
            if (this.$route.params.termyear) {
               this.edit_cca_year = this.$route.params.termyear.year;
               this.edit_cca_term = this.$route.params.termyear.term;
            } else {
               this.edit_cca_year = this.$globalstore.appsettings.currentyearterm.year;
               this.edit_cca_term = this.$globalstore.appsettings.currentyearterm.term;
            }
            this.loadScheduleList();
            this.loadCategoryList();
         }
      },
   };
</script>

<style>
   tr.v-data-table__selected {
      /* background: #7d92f5 !important; */
      background: #ffcdd2 !important;
   }
</style>
